export default __webpack_public_path__ + "static/media/dot_flexible.ba5dbafb.svg";